import { DirtyProvider } from '../../hooks/useDirtyProvider';
import { DisabledPrinterProvider } from '../../hooks/useIsDisabledPrinter';
import { useOfflineRedirect } from '../../hooks/useOfflineRedirect';
import { useIsOnline } from '../../hooks/useIsOnline';
import Header from '../header';
import SSCCOfflineCard from '../cards/SSCCOfflineCard';

type LayoutProps = {
  children: string | JSX.Element | JSX.Element[];
};

export default function Layout({ children }: LayoutProps) {
  const { isOnline } = useIsOnline();

  // Enable offline redirect functionality across all pages
  useOfflineRedirect();

  return (
    <>
      <DirtyProvider>
        <DisabledPrinterProvider>
          <Header />
          {isOnline ? children : <SSCCOfflineCard />}
        </DisabledPrinterProvider>
      </DirtyProvider>
    </>
  );
}
